import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import './BackToHome.css';

const BackToHome = () => {
  const navigate = useNavigate();

  return (
    <div className="back-to-home-container">
      <Button 
        variant="outline-primary" 
        onClick={() => navigate('/')}
        className="back-to-home-btn"
      >
        <FaHome className="me-2" />
        Back to Home
      </Button>
    </div>
  );
};

export default BackToHome;
